import 'css-chunksrc/client/pages/zonePage/wbsPage/sort/styles.scss';export default {
  "sort": "_sort_wgm2c_1",
  "label": "_label_wgm2c_9",
  "input": "_input_wgm2c_15",
  "placeholder": "_placeholder_wgm2c_31",
  "icon": "_icon_wgm2c_39",
  "listRoot": "_listRoot_wgm2c_47",
  "list": "_list_wgm2c_47",
  "item": "_item_wgm2c_63",
  "option": "_option_wgm2c_76",
  "selected": "_selected_wgm2c_83",
  "opened": "_opened_wgm2c_96"
};